var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('intro-section'),_c('digital-workflow-list'),_c('div',{staticStyle:{"background":"#fff"}},[_c('appointment-form-2x2')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }